
/**
 * ═══════════════════════════════════════════════════════════════════════════
 * REGISTRE DES COMPOSANTS - VERSION 5.2
 * ═══════════════════════════════════════════════════════════════════════════
 */

import React from 'react';

import Table from 'react-bootstrap/Table';
import Modal from 'react-bootstrap/Modal';

import { FaMapMarkerAlt, FaUserAlt, FaAddressCard, FaPhoneAlt, FaPen } from 'react-icons/fa';
import { MdSmartphone, MdAlternateEmail, MdAddShoppingCart, MdClose } from 'react-icons/md';
import '../profileAddressPhoneModals.css';

import { getPublicIdentifier } from '../../../utils/publicIdentifier';
import Slider from '../../slider/swiperProduct';
import LoadingSwiper from '../../slider/loadindSwiper';
import SwiperfollowShopUserMatrix from '../../slider/swiperUserProd/swiperPageMatrix';
import MatrixCardsGrid from '../../slider/swiperUserProd/MatrixCardsGrid';
import SwiperCategoriesMatrix from '../../slider/swiperUserProd/swiperCategoriesMatrix';
import SwiperPubCategoryProdMatrix from '../../slider/swiperUserProd/swiperPubCategoryProdMatrix';

import FollowPage from '../../pages/lakayUser/followPage';
import ProductGridPage from '../../pageInside/ProductGridPage';
import ProductGridShop from '../../pageInside/ProductGridShop';
import OrdersGridPage from '../../pageInside/OrdersGridPage';
import ProductGridSearch from '../../pageInside/ProductGridSearch';
import {
  InvestmentDetailSection,
  InvestmentHomeSection,
} from '../../pageInside/investment/InvestmentSections';
import {
  JobDetailSection,
  JobHomeSection,
} from '../../pageInside/jobs/JobSections';

import Card from '../../pageInside/Card';
import ButtonPagination from '../../pageInside/ButtonPagination';
import PaginationInfo from '../../pageInside/paginationInfo';

import UserTelephone from '../../pages/addTelephone';
import EditFullNameModal from '../../pages/profile/EditFullNameModal';
import DefaultLanguageSection from '../../pages/profile/DefaultLanguageSection';
import { isAuthenticated, removeItem } from '../../auth';
import AddressUser from '../../pageInside/AddressUser';

import {
  Family,
  Adminstrator,
  Investment,
  Assoociate,
  Provider,
  Seller,
  Customer,
} from '../../pageInside/Rolle';

import CardCart from '../../pageInside/CardCart';
import CardUnAvailbable from '../../pageInside/CardCartAvailable';
import Checkout from '../../pageInside/CheckoutProd';
import CartCheckin from '../../pageInside/cartCheckin/CartCheckin';
import CartUnavailableNotice from '../../pageInside/cartCheckin/CartUnavailableNotice';

import CardOrders from '../../pageInside/CardOrders2';
import OrdersView from '../../pages/OrdersView';
import FiltersOrders from '../../pageInside/filersOrder';
import OrderNoteMessage from '../../pageInside/orderNoteMessage';

import Products from '../../pageInside/product';
import LakayUser from '../../pageInside/lakayUser';
import NewProduct from '../../pageInside/NewProduct';

import Vote, { ratingVote } from '../../pageInside/commentaire/vote';
import EmblaCarousel from '../../slider/ProdViewSlider/slider';
import TabsElakay, { tabElakay } from '../../pageInside/html/formTabs';
import Price from '../../pageInside/productsPrice';
import PrevviewProFilt from '../../pageInside/prevviewProFilt';
import CommentaireUser from '../../pageInside/commentaire/comentairePro';
import AddCommentProduct from '../../pageInside/commentaire/UserAddCommentsProduct';

import SliderPun135 from '../../slider/swiperPub1500x400';
import ShopHeroSlider, { heroFromPub } from '../../dynamicSwipers/ShopHeroSlider';
import HeaderShopSeller from '../../Layout/headerShopSeller';

import elakayEmptyBox from '../../Layout/icon/elakayEmptyBox.png';
import CartEmpty from '../CartEmpty';
import NoOrdersImage from '../../Layout/imgs/no-ordres1.png';
import EmptyProductImage from '../../Layout/icon/Unavailable.png';
import imgProductLakay from '../../Layout/imgs/md3.jpg';

import { elakay_API, toImageUrl } from '../../../config';
import { elakayAutoText, getElakayLanguageContext } from "../dataElakay";


/* ✅ Code seulement APRÈS tous les imports */

let __elakayInfoSource;

const __setElakayInfoSource = (infoSource) => {
  if (infoSource) __elakayInfoSource = infoSource;
};

// Current language source: the app-wide one (always up to date after a language switch), else
// the infoSource this module last rendered with.
const __elakayLanguageSource = () => getElakayLanguageContext?.() || __elakayInfoSource;

const __elakayText = (key, fallback) =>
  __elakayLanguageSource()
    ?.laguangeElakay?.(
      'frontElakayHardcodedText',
      __elakayLanguageSource().languageAPI
    )
    ?.componentRegistry?.[key] || fallback;
// ─────────────────────────────────────────────────────────────────────────────
// HELPER (identique v5.1)
// ─────────────────────────────────────────────────────────────────────────────



const ensureArray = (data, fallback = []) => {
    if (Array.isArray(data)) return data;
    if (data === null || data === undefined) return fallback;
    if (typeof data === 'object') {
        if (Array.isArray(data.items))    return data.items;
        if (Array.isArray(data.products)) return data.products;
        if (Array.isArray(data.data))     return data.data;
    }
    return fallback;
};

// ─────────────────────────────────────────────────────────────────────────────
// COMPOSANT: SLIDER WITH LOADING
// sectionProps: { circle, myStyles, type_Animation, animationColors, inView }
// ─────────────────────────────────────────────────────────────────────────────

const SliderWithLoading = ({
    data,
    infoSource,
    homeStyles,
    sectionProps = {},    // ← AJOUT v5.2
    ...props
}) => {
  __setElakayInfoSource(infoSource);
    // Lire les options depuis sectionProps (DB), fallback sur valeurs v5.1
    const {
        circle         = false,
        myStyles       = homeStyles,
        type_Animation,
        animationColors,
        inView,
    } = sectionProps;

    if (!data || (Array.isArray(data) && data.length === 0)) {
        return (
            <LoadingSwiper
                circle={circle}
                myStyles={myStyles || homeStyles}
            />
        );
    }

    // N'injecter les props animation que si définies en DB
    const animationProps = {};
    if (type_Animation)                        animationProps.type_Animation  = type_Animation;
    if (animationColors)                       animationProps.animationColors = animationColors;
    if (inView !== undefined && inView !== null) animationProps.inView         = inView;

    return (
        <Slider
            infoSource={infoSource}
            ProductSwiper={data}
            myStyles={myStyles || homeStyles}
            circle={circle}
            {...animationProps}
            {...props}
        />
    );
};

// ─────────────────────────────────────────────────────────────────────────────
// COMPOSANT: CATEGORY PRODUCTS LOOP
// sectionProps: { type_Animation, animationColors, inView, myStyles, showB }
// ─────────────────────────────────────────────────────────────────────────────

const CategoryProductsLoop = ({
    data,
    infoSource,
    laguangeElakay,
    homeStyles,
    sectionProps = {},    // ← AJOUT v5.2
    // Props directes conservées pour compatibilité adapterProps
    type_Animation,
    animationColors,
    inView,
    myStyles,
    showB,
    cartItems,
    nameSlider,
    ...props
}) => {
    if (!data || !Array.isArray(data) || data.length === 0) {
        return null;
    }

    // sectionProps prioritaire sur les props directes
    const _type_Animation  = sectionProps.type_Animation  ?? type_Animation  ?? null;
    const _animationColors = sectionProps.animationColors ?? animationColors ?? null;
    const _inView          = sectionProps.inView          ?? inView          ?? null;
    const _myStyles        = sectionProps.myStyles        ?? myStyles        ?? homeStyles ?? { width: '100%' };
    const _showB           = sectionProps.showB           ?? showB           ?? false;

    // N'injecter les props animation que si définies
    const animationProps = {};
    if (_type_Animation)                          animationProps.type_Animation  = _type_Animation;
    if (_animationColors)                         animationProps.animationColors = _animationColors;
    if (_inView !== undefined && _inView !== null) animationProps.inView         = _inView;

    return (
        <>
        
            {data.map((category, index) => {
                const categoryPublicId = getPublicIdentifier(category);
                return (
                <div key={categoryPublicId || index}>
                    <Slider
                        ProductSwiper={category?.products}
                        laguangeElakay={laguangeElakay}
                        infoSource={infoSource}
                        User={cartItems}
                        nameSlider={category.item_name}
                        linkSlider={`/product/${categoryPublicId}`}
                        showB={_showB}
                        myStyles={_myStyles}
                        {...sectionProps}
                        {...animationProps}
                        {...props}
                    />
                </div>
                );
            })}
        </>
    );
};

// ─────────────────────────────────────────────────────────────────────────────
// COMPOSANT: USER INFO CARD
// sectionProps: { premiumStyles }
// ─────────────────────────────────────────────────────────────────────────────

const UserInfoCard = ({
    data,
    infoSource,
    premiumStyles,        // ← prop directe v5.1 (conservée)
    sectionProps = {},    // ← AJOUT v5.2
    ...props
}) => {
    // sectionProps prioritaire sur prop directe
    const _premiumStyles = sectionProps.premiumStyles ?? premiumStyles;

    const userInfo    = data || infoSource?.userInfo || {};
    const telephone   = infoSource?.phoneUser?.filter(k => k.default === true)?.[0];
    // My Profile "Edit Full Name": first/last name only (never the email).
    const [editNameOpen, setEditNameOpen] = React.useState(false);
    const [nameSaved, setNameSaved]       = React.useState(false);
    const handleNameSaved = async () => {
        // Refreshes infoSource.userInfo -> this card AND the header name.
        await infoSource?.readUser?.(isAuthenticated()?.token, ["getUserInfo"]);
        setEditNameOpen(false);
        setNameSaved(true);
    };
    const AddressTrue = infoSource?.address?.filter(k => k.addressDefault === true)?.[0];

    const roleUser = () => (
        <>
            {Customer(true)     && <span>{infoSource.laguangeElakay('title', infoSource.languageAPI).royalty}</span>}
            {Seller(true)       && <span>{infoSource.laguangeElakay('title', infoSource.languageAPI).seller}</span>}
            {Provider(true)     && <h4>{infoSource.laguangeElakay('title', infoSource.languageAPI).provider}</h4>}
            {Assoociate(true)   && <span>{infoSource.laguangeElakay('title', infoSource.languageAPI).assoociate}</span>}
            {Investment(true)   && <span>{infoSource.laguangeElakay('title', infoSource.languageAPI).investment}</span>}
            {Adminstrator(true) && <span>{infoSource.laguangeElakay('title', infoSource.languageAPI).Admin}</span>}
            {Family()           && <span>{infoSource.laguangeElakay('title', infoSource.languageAPI).family}</span>}
        </>
    );

    return (
        <div className="row mt-4 mb-4 justify-content-center user-profile-premium">
            {_premiumStyles && <style>{_premiumStyles}</style>}
            <div className="col col-12 col-md-10 col-lg-9 col-xl-8 p-0" style={{ border: "1px solid Gainsboro", borderRadius: "10px" }}>
                <div className="col col-12 col-md-12" style={{ textAlign: "center", backgroundColor: "WhiteSmoke" }}>
                    <h3>{infoSource.laguangeElakay('title', infoSource.languageAPI).yourInfo} {roleUser()}</h3>
                </div>
                <div className="m-3">
                    <Table>
                        <tbody>
                            <tr>
                                <td>
                                    <h4 className="prf-name-row">
                                        <span style={{ fontSize: "30px", paddingRight: "12px" }}><FaUserAlt /></span>
                                        <span>{`${userInfo.firstname} ${userInfo.lastname}`}</span>
                                        <button
                                            type="button"
                                            className="prf-edit-name-btn"
                                            onClick={() => { setNameSaved(false); setEditNameOpen(true); }}
                                            aria-label={elakayAutoText("h_prf_editName_open", "Edit full name")}
                                            title={elakayAutoText("h_prf_editName_open", "Edit full name")}
                                        >
                                            <FaPen aria-hidden="true" />
                                        </button>
                                    </h4>
                                    {nameSaved && (
                                        <div className="epm-banner prf-success" role="status">
                                            {elakayAutoText("h_prf_profileUpdated", "Profile Updated Successfully")}
                                        </div>
                                    )}
                                    <EditFullNameModal
                                        show={editNameOpen}
                                        firstname={userInfo.firstname}
                                        lastname={userInfo.lastname}
                                        onHide={() => setEditNameOpen(false)}
                                        onSaved={handleNameSaved}
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <h5>
                                        <span style={{ fontSize: "30px", paddingRight: "20px" }}><MdAlternateEmail /></span>
                                        {userInfo.email}
                                    </h5>
                                </td>
                            </tr>
                            {telephone && (
                                <tr>
                                    <td>
                                        <div>
                                            <h5>
                                                <span style={{ fontSize: "30px", paddingRight: "20px" }}><FaPhoneAlt /></span>
                                                {telephone.International}
                                            </h5>
                                        </div>
                                    </td>
                                </tr>
                            )}
                            {/* Default address + Default Language (users.language) side by side. */}
                            <tr>
                                <td>
                                    <div className="prf-address-row">
                                        {AddressTrue && (
                                        <h5>
                                            <span style={{ fontSize: "30px", paddingRight: "20px" }}><FaMapMarkerAlt /></span>
                                            <span>
                                                {AddressTrue.firstName} {AddressTrue.lastName}
                                                <br />
                                                <span style={{ paddingLeft: "20px" }}>
                                                    {AddressTrue.Address1}, {AddressTrue.city} {AddressTrue.State} {AddressTrue.postalCode} {AddressTrue.country}
                                                </span>
                                                <br />
                                                <span style={{ paddingLeft: "21px", fontSize: "14px" }}>
                                                    {infoSource.laguangeElakay('title', infoSource.languageAPI).defaultDeliryAdress}
                                                </span>
                                            </span>
                                        </h5>
                                        )}
                                        <DefaultLanguageSection infoSource={infoSource} />
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </Table>
                </div>
            </div>
        </div>
    );
};

// ─────────────────────────────────────────────────────────────────────────────
// COMPOSANT: USER BUTTONS GROUP
// sectionProps: {} — pas de config DB pour ce composant
// ─────────────────────────────────────────────────────────────────────────────

const UserButtonsGroup = ({
    infoSource,
    sectionProps = {},    // ← AJOUT v5.2 (non utilisé, prêt pour extension)
    handePage,
    ...props
}) => {
    return (
        <div className="row mt-3 mb-3 justify-content-center">
            <div className="col col-12 col-md-8">
                <div className="row justify-content-center">
                    <div className="bg clearfix">
                        <div id="agent-profile-trigger-slot" className="agent-profile-trigger-slot" />
                        <button
                            onClick={() => handePage?.("pageAddress")}
                            className="btn btn-outline-info pt-2 pb-2 pr-3 pl-3 rounded-4 float-left"
                        >
                            <span style={{ fontSize: "20px", paddingRight: "6px" }}><FaAddressCard /></span>
                            {infoSource.laguangeElakay('Button', infoSource.languageAPI).addAdress}
                        </button>
                        <button
                            onClick={() => handePage?.("pagePhone")}
                            className="btn btn-outline-info pt-2 pb-2 pr-3 pl-3 rounded-4 float-right"
                        >
                            <span style={{ fontSize: "20px", paddingRight: "6px" }}><MdSmartphone /></span>
                            {infoSource.laguangeElakay('Button', infoSource.languageAPI).addTel}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

// ─────────────────────────────────────────────────────────────────────────────
// COMPOSANT: USER MODAL
// sectionProps: { modalSize }
// ─────────────────────────────────────────────────────────────────────────────

// Redesign (2026-08-31): this Modal had NO Modal.Header at all -- no icon,
// title, subtitle, or X button, just a bare `modal-90w` (~90% of the
// viewport) body. The header below is the one shared "same visual
// language" surface for both Address and Telephone (spec §4); each of
// AddressUser.jsx/addTelephone.jsx keeps its own business logic untouched,
// this only wraps them. modalSize/dialogClassName intentionally dropped in
// favor of .epm-modal-dialog's own fixed max-width -- this component has a
// single registration (pagesConfig.js's "userModal"), used only for this
// address/phone toggle, so narrowing it here has no other blast radius.
const USER_MODAL_META = {
    pagePhone: {
        Icon: MdSmartphone,
        title: (infoSource) => infoSource?.laguangeElakay?.('title', infoSource?.languageAPI)?.addPhoneNumber
            || elakayAutoText("h_epm_addPhone_title", "Add phone number"),
        subtitle: () => elakayAutoText("h_epm_addPhone_subtitle", "Add a phone number to stay connected and receive important updates."),
    },
    pageAddress: {
        Icon: FaMapMarkerAlt,
        title: (infoSource) => elakayAutoText("h_epm_address_title", "Your addresses"),
        subtitle: () => elakayAutoText("h_epm_address_subtitle", "Add a shipping address or manage the ones you already have."),
    },
};

const UserModal = ({
    data,
    infoSource,
    sectionProps = {},    // ← AJOUT v5.2
    handePage,
    ...props
}) => {
    const { showModal, pagePhone, pageAddress } = data || {};
    const metaKey = pagePhone ? 'pagePhone' : 'pageAddress';
    const meta = USER_MODAL_META[metaKey];
    const HeaderIcon = meta.Icon;

    return (
        <div className="container">
            <div className="row justify-content-center">
                <Modal
                    show={showModal}
                    onHide={() => handePage?.()}
                    dialogClassName={`epm-modal-dialog epm-modal-dialog--${pagePhone ? 'phone' : 'address'}`}
                    contentClassName="epm-modal-content"
                    aria-labelledby="user-modal-title"
                     size="xl"
                     fullscreen
                    centered
                >
                    <div className="epm-modal-header">
                        <span className="epm-modal-icon"><HeaderIcon /></span>
                        <div className="epm-modal-heading">
                            <h5 id="user-modal-title" className="epm-modal-title">{meta.title(infoSource)}</h5>
                            <p className="epm-modal-subtitle">{meta.subtitle()}</p>
                        </div>
                        <button
                            type="button"
                            className="epm-modal-close"
                            onClick={() => handePage?.()}
                            aria-label={elakayAutoText("h_epm_closeModal", "Close")}
                        >
                            <MdClose />
                        </button>
                    </div>
                    <Modal.Body className="epm-modal-body">
                        {pagePhone   && <UserTelephone handePage={handePage} infoSource={infoSource} {...props}/>}
                        {pageAddress && <AddressUser handePage={handePage} onSaved={() => handePage?.()} infoSource={infoSource} {...props} />}
                    </Modal.Body>
                </Modal>
            </div>
        </div>
    );
};

// ─────────────────────────────────────────────────────────────────────────────
// HELPER (identique v5.1)
// ─────────────────────────────────────────────────────────────────────────────

// ═══════════════════════════════════════════════════════════════════════════
// COMPOSANT: CART HEADER
// sectionProps: { title }
// ═══════════════════════════════════════════════════════════════════════════

const CartHeader = ({
    data,
    infoSource,
    sectionProps = {},    // ← AJOUT v5.2
    ...props
}) => {
    const { title } = sectionProps;    // facultatif — surcharge le titre i18n
    const cartItems = ensureArray(data);

    return (
        <div className="cart-header mr-2">
            <h1 className="cart-title">
                {title || infoSource?.laguangeElakay?.('title', infoSource?.languageAPI)?.yourCart || elakayAutoText("h_037ffcd082e886", "Votre Panier")}
                <span className="cart-badge">
                    {cartItems.length} {cartItems.length === 1 ? elakayAutoText("h_dd3b86d1ef21b9", "Product") : elakayAutoText("h_fe0a091fdbfb3e", "Products")}
                </span>
            </h1>
        </div>
    );
};

// ═══════════════════════════════════════════════════════════════════════════
// COMPOSANT: CART ITEMS LIST
// sectionProps: { showUnavailable }
// ═══════════════════════════════════════════════════════════════════════════

const CartItemsList = ({
    data,
    infoSource,
    laguangeElakay,
    sectionProps = {},    // ← AJOUT v5.2
    Saddress,
    SetShipAmount,
    cartItems,
    ...props
}) => {
    const { showUnavailable = true } = sectionProps;    // v5.1 montrait toujours les unavailable
    const getCartItems = ensureArray(data);

    if (getCartItems.length === 0) {
        return null;
    }

    return (
        <div className="cart-items-column">
            {getCartItems.map((product, i) => {
                if (!product) return null;

                if (product.productID && product.quantity > 0) {
                    return (
                        <CardCart
                            key={product._id || product.productID?._id || i}
                            laguangeElakay={laguangeElakay}
                            infoSource={infoSource}
                            shipAmout={[]}
                            SetShipAmount={SetShipAmount}
                            Saddress={Saddress}
                            countProuct={product.count}
                            product={product}
                            {...props}
                        />
                    );
                } else {
                    // showUnavailable depuis sectionProps (DB) — default true = comportement v5.1
                    return showUnavailable ? (
                        <CardUnAvailbable
                            key={product._id || i}
                            product={product}
                            cartItems={cartItems}
                            infoSource={infoSource}
                            {...props}
                        />
                    ) : null;
                }
            })}
        </div>
    );
};

// ═══════════════════════════════════════════════════════════════════════════
// COMPOSANT: CART CHECKOUT
// sectionProps: {} — pas de config DB pour ce composant
// ═══════════════════════════════════════════════════════════════════════════

const CartCheckout = ({
    data,
    infoSource,
    laguangeElakay,
    sectionProps = {},    // ← AJOUT v5.2 (non utilisé, prêt pour extension)
    Saddress,
    setSAddressFinal,
    ...props
}) => {
    const cartItems = ensureArray(data);
    const unavailableNotice = (
        <CartUnavailableNotice
            lines={infoSource?.cartUnavailable}
            onRemove={async (cartItemId) => {
                const { token } = isAuthenticated() || {};
                if (!token) return;
                await removeItem(token, { CartID: cartItemId });
                if (typeof infoSource?.cartItems === "function") await infoSource.cartItems(token);
            }}
        />
    );

    if (cartItems.length === 0) {
        return unavailableNotice;
    }

    return (
        <div className="cart-checkout-column">
            {unavailableNotice}
            <Checkout
                Saddress={Saddress}
                setSAddressFinal={setSAddressFinal}
                addressSel={infoSource?.address}
                products={cartItems}
                cart={true}
                laguangeElakay={laguangeElakay}
                infoSource={infoSource}
                {...props}
            />
            {/* Check-in: choose which cart products to pay now (opens a modal; the cart itself is unchanged). */}
            <CartCheckin
                infoSource={infoSource}
                Saddress={Saddress}
                setSAddressFinal={setSAddressFinal}
                laguangeElakay={laguangeElakay}
            />
        </div>
    );
};

// ═══════════════════════════════════════════════════════════════════════════
// COMPOSANT: CART EMPTY
// sectionProps: { emptyText }
// ═══════════════════════════════════════════════════════════════════════════

// ─────────────────────────────────────────────────────────────────────────────
// COMPOSANT: CART FULL LAYOUT
// sectionProps: { cartStyles, showUnavailable }
// ─────────────────────────────────────────────────────────────────────────────

const CartFullLayout = ({
    data,
    infoSource,
    laguangeElakay,
    sectionProps = {},    // ← AJOUT v5.2
    Saddress,
    setSAddressFinal,
    SetShipAmount,
    // cartItems,
    cartStyles,           // ← prop directe v5.1 (conservée)
    ...props
}) => {
    // sectionProps prioritaire sur prop directe
    const _cartStyles      = sectionProps.cartStyles      ?? cartStyles;
    const _showUnavailable = sectionProps.showUnavailable ?? true;
    const {cartItems, getCartItems } = infoSource || {};    // v5.1 montrait toujours les unavailable

    // const getCartItems = ensureArray(data);

    if (getCartItems.length === 0) {
        return null;
    }

    return (
        <div className="cart-page-container">
            {_cartStyles && <style>{_cartStyles}</style>}

            <CartHeader data={getCartItems} infoSource={infoSource} sectionProps={sectionProps} />

            <div className="row">
                <div className="col-12 col-lg-8">
                    <CartItemsList
                        data={getCartItems}
                        infoSource={infoSource}
                        laguangeElakay={laguangeElakay}
                        sectionProps={{ showUnavailable: _showUnavailable }}
                        Saddress={Saddress}
                        SetShipAmount={SetShipAmount}
                        cartItems={cartItems}
                        {...props}
                    />
                </div>
                <div className="col-12 col-lg-4">
                    <CartCheckout
                        data={getCartItems}
                        infoSource={infoSource}
                        laguangeElakay={laguangeElakay}
                        sectionProps={{}}
                        Saddress={Saddress}
                        setSAddressFinal={setSAddressFinal}
                        {...props}
                    />
                </div>
            </div>
        </div>
    );
};

// ─────────────────────────────────────────────────────────────────────────────
// COMPOSANT: ORDERS HEADER
// sectionProps: { showFilterButton }
// ─────────────────────────────────────────────────────────────────────────────

const OrdersHeader = ({
    data,
    infoSource,
    sectionProps = {},    // ← AJOUT v5.2
    skip,
    limit,
    sizeOrders,
    setShowFilterOrder,
    ...props
}) => {
    const { showFilterButton = true } = sectionProps;    // v5.1 montrait toujours le bouton
    const orders = data || [];

    if (orders.length > 0) {
        return (
            <div className="col col-12 orders-header-premium">
                <h4 className="text-dark m-2 p-0">
                    {showFilterButton && (
                        <div
                            className="btn btn-dark btn-md py-1 rounded-4"
                            onClick={() => setShowFilterOrder?.(true)}
                            role="button"
                            tabIndex={0}
                        >
                            {infoSource.language(infoSource, "title", "filters")}
                        </div>
                    )}
                    {infoSource.laguangeElakay("title", infoSource.languageAPI).totalOrder}{" "}
                    {(skip - parseInt(limit, 10)) + parseInt(limit, 10) + 1} -{" "}
                    {skip + parseInt(limit, 10) > sizeOrders
                        ? sizeOrders
                        : skip + parseInt(limit, 10)}{" "}
                    {infoSource.language(infoSource, "label", "of")} {sizeOrders}
                </h4>
            </div>
        );
    }

    return (
        <div className="col-md-9 no-orders-section-premium" style={{ textAlign: "center" }}>
            <h4 className="text-dark m-2 p-0">
                {showFilterButton && (
                    <div
                        // className="orders-filter-btn-premium"
                        className="btn btn-dark btn-md py-1 rounded-4"
                        onClick={() => setShowFilterOrder?.(true)}
                        role="button"
                        tabIndex={0}
                    >
                        {infoSource.language(infoSource, "title", "filters")}
                    </div>
                )}
            </h4>
            <img
                className="rounded no-orders-image-premium"
                src={NoOrdersImage}
                alt={__elakayText("t002", "no orders")}
                style={{ 
                        display: 'block',
                        margin: '0 auto',
                        width: "100%"
                        }}
            />
        </div>
    );
};

// ─────────────────────────────────────────────────────────────────────────────
// COMPOSANT: ORDERS LIST
// sectionProps: { containerClass }
// ─────────────────────────────────────────────────────────────────────────────

const OrdersList = ({
    data,
    infoSource,
    sectionProps = {},    // ← AJOUT v5.2
    loadingTrakingOder,
    setTrackingOrder,
    setShowTrakingOrder,
    bntOderView,
    ...props
}) => {
    const { containerClass = 'container m-2 orders-card-container' } = sectionProps;    // v5.1 avait cette classe hardcodée
    const orders = data || [];

    return (
        <>
            {orders.map((orderItem, oIndex) => (
                <div key={orderItem._id || oIndex} className={containerClass}>
                    <CardOrders
                        laguangeElakay={infoSource.laguangeElakay}
                        infoSource={infoSource}
                        product={orderItem}
                        loadingTrakingOder={loadingTrakingOder}
                        setTrackingOrder={setTrackingOrder}
                        setShowTrakingOrder={setShowTrakingOrder}
                        bntOderView={bntOderView}
                        {...props}
                    />
                </div>
            ))}
        </>
    );
};

// ─────────────────────────────────────────────────────────────────────────────
// COMPOSANT: ORDERS EMPTY
// sectionProps: { showFilterButton }
// ─────────────────────────────────────────────────────────────────────────────

const OrdersEmpty = ({
    infoSource,
    sectionProps = {},    // ← AJOUT v5.2
    setShowFilterOrder,
    ...props
}) => {
    const { showFilterButton = true } = sectionProps;

    return (
        <div className="col-md-9 no-orders-section-premium" style={{ textAlign: "center" }}>
            <h4 className="text-dark m-2 p-0">
                {showFilterButton && (
                    <div
                        className="orders-filter-btn-premium"
                        onClick={() => setShowFilterOrder?.(true)}
                        role="button"
                        tabIndex={0}
                    >
                        {infoSource.language(infoSource, "title", "filters")}
                    </div>
                )}
            </h4>
            <img
                className="rounded no-orders-image-premium"
                src={NoOrdersImage}
                alt={__elakayText("t002", "no orders")}
                style={{ 
                        display: 'block',
                        margin: '0 auto',
                        width: "100%"
                        }}
            />
        </div>
    );
};

// ─────────────────────────────────────────────────────────────────────────────
// COMPOSANT: ORDERS FULL LAYOUT
// sectionProps: { backgroundColor, showFilterButton, containerClass }
// ─────────────────────────────────────────────────────────────────────────────

const OrdersFullLayout = ({
    data,
    infoSource,
    sectionProps = {},    // ← AJOUT v5.2
    skip,
    limit,
    sizeOrders,
    setShowFilterOrder,
    loadingTrakingOder,
    setTrackingOrder,
    setShowTrakingOrder,
    bntOderView,
    loadMore,
    loadMore0,
    ...props
}) => {
    const {
        backgroundColor  = "WhiteSmoke",    // v5.1 avait "WhiteSmoke" hardcodé
        showFilterButton = true,
        containerClass,
    } = sectionProps;

    const orders = data || [];

    return (
        <div
            className="row my-4 justify-content-center orders-premium-page"
            style={{ backgroundColor }}
        >
            <OrdersHeader
                data={orders}
                infoSource={infoSource}
                sectionProps={{ showFilterButton }}
                skip={skip}
                limit={limit}
                sizeOrders={sizeOrders}
                setShowFilterOrder={setShowFilterOrder}
            />

            {orders.length > 0 && (
                <OrdersList
                    data={orders}
                    infoSource={infoSource}
                    sectionProps={{ containerClass }}
                    loadingTrakingOder={loadingTrakingOder}
                    setTrackingOrder={setTrackingOrder}
                    setShowTrakingOrder={setShowTrakingOrder}
                    bntOderView={bntOderView}
                />
            )}

            {orders.length > 0 && (
                <ButtonPagination
                    infoSource={infoSource}
                    size={orders.length}
                    siseProduct={sizeOrders}
                    skip={skip}
                    limit={parseInt(limit, 10)}
                    loadMore={loadMore}
                    loadMore0={loadMore0}
                />
            )}
        </div>
    );
};

// ─────────────────────────────────────────────────────────────────────────────
// COMPOSANT: ORDERS MODALS
// sectionProps: {} — structure fixe, pas de config DB
// ─────────────────────────────────────────────────────────────────────────────

const OrdersModals = ({
    data,
    infoSource,
    sectionProps = {},    // ← AJOUT v5.2 (non utilisé, prêt pour extension)
    token,
    filtOrders,
    limit,
    setLimit,
    setFiltOrders,
    trackingOrder,
    getOrderID,
    pageImgSms,
    setPageImgSms,
    graphicNote,
    setGraphicNote,
    graphicNoteBs,
    setGraphicNoteBs,
    graphicImgBs,
    setGraphicImgBs,
    setShowOrderNote,
    readOnlyOrderView = false,
    ...props
}) => {
    const {
        showFilterOrder,
        setShowFilterOrder,
        showTrakingOrder,
        setShowTrakingOrder,
        showItermOrder,
        setShowItermOrder,
        showOrderNote,
    } = data || {};

    // Filter Modal (identique v5.1)
    const filterOrdersView = () => (
        <Modal
            size="md"
            show={showFilterOrder}
            onHide={() => setShowFilterOrder(false)}
            aria-labelledby="filter-modal-title"
            centered
            dialogClassName="orders-filter-modal"
            backdrop="static"
        >
            <button 
            type="button" 
            className="orders-filter-modal-close" 
            onClick={() => setShowFilterOrder(false)} 
            aria-label={__elakayText("t004", "Close")}
            >×</button>
            <div className="orders-filter-modal-header">
                <h2 id="filter-modal-title" className="orders-filter-modal-title">
                    {infoSource.language(infoSource, "title", "ordFilt")}
                </h2>
            </div>
            <div className="orders-filter-modal-body">
                <FiltersOrders
                    laguangeElakay={infoSource.laguangeElakay}
                    infoSource={infoSource}
                    limit={parseInt(limit, 10)}
                    setLimit={setLimit}
                    setFiltOrders={setFiltOrders}
                    setShowFilterOrder={setShowFilterOrder}
                    filtOrders={filtOrders}
                />
            </div>
        </Modal>
    );

    // Tracking Modal (identique v5.1)
    const trackingOrderView = () => (
        <Modal
            show={showTrakingOrder}
            onHide={() => setShowTrakingOrder?.(false)}
            centered
            dialogClassName="orders-tracking-modal"
            aria-labelledby="tracking-modal-title"
            backdrop="static"
        >
            <button type="button" className="orders-tracking-modal-close" onClick={() => setShowTrakingOrder?.(false)} aria-label={__elakayText("t004", "Close")}>×</button>
            {trackingOrder ? (
                <iframe className="orders-tracking-iframe" src={trackingOrder} title={__elakayText("t006", "Tracking Order")} />
            ) : (
                <h2 className="text-center m-3">{infoSource.language(infoSource, "title", "orderprocess")}</h2>
            )}
        </Modal>
    );

    // Step Page Message (identique v5.1)
    const stepPageMessage = () => {
        const StyleMenu0 = { borderLeft: "1px solid lightgrey", borderRight: "1px solid lightgrey", borderBottom: "None", backgroundColor: "White" };
        const StyleMenu1 = { borderLeft: "1px solid lightgrey", borderRight: "1px solid lightgrey", backgroundColor: "White", borderBottom: "6px solid #007399" };
        const plsh1 = pageImgSms  ? StyleMenu1 : StyleMenu0;
        const plsh2 = !pageImgSms ? StyleMenu1 : StyleMenu0;

        return (
            <div className="row justify-content-center">
                <div className="col-xs-12">
                    <div className="col-12 col-md-12" style={{ textAlign: "center" }}>
                        <div className="row">
                            <div className="col col-6 orders-step-tab" style={plsh2} onClick={() => setPageImgSms?.(false)} role="button" tabIndex={0}>{__elakayText("t007", "Message")}</div>
                            <div className="col-6 orders-step-tab"    style={plsh1} onClick={() => setPageImgSms?.(true)}  role="button" tabIndex={0}>{__elakayText("t008", "Images")}</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    // Note Message Modal (identique v5.1)
    const viewOrderNoteMessage = () => (
        <Modal size="md" show={showOrderNote} onHide={() => setShowOrderNote?.(false)} dialogClassName="orders-note-modal" aria-labelledby="order-note-modal-title" centered backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title id="order-note-modal-title">{stepPageMessage()}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <OrderNoteMessage
                    orderID={getOrderID?.oid}
                    token={token}
                    pageImgSms={pageImgSms}
                    infoSource={infoSource}
                    setGraphicNote={setGraphicNote}
                    graphicNote={graphicNote}
                    graphicNoteBs={graphicNoteBs}
                    setGraphicNoteBs={setGraphicNoteBs}
                    graphicImgBs={graphicImgBs}
                />
            </Modal.Body>
        </Modal>
    );

    // Item Order Modal (identique v5.1)
    const itemOrderView = () => (
        <Modal size="xl" show={showItermOrder} onHide={() => setShowItermOrder?.(false)} dialogClassName="orders-item-modal" aria-labelledby="order-items-modal-title" centered backdrop="static">
            <button type="button" className="orders-item-modal-close" onClick={() => setShowItermOrder?.(false)} aria-label={__elakayText("t004", "Close")}>×</button>
            <div className="orders-item-modal-body">
                {viewOrderNoteMessage()}
                <OrdersView
                    infoSource={infoSource}
                    getOrderID={getOrderID}
                    setShowOrderNote={setShowOrderNote}
                    setGraphicNoteBs={setGraphicNoteBs}
                    setGraphicImgBs={setGraphicImgBs}
                    readOnly={readOnlyOrderView}
                />
            </div>
        </Modal>
    );

    return (
        <>
            {filterOrdersView()}
            {trackingOrderView()}
            {itemOrderView()}
        </>
    );
};

// ─────────────────────────────────────────────────────────────────────────────
// COMPOSANT: PRODUCTS BY CATEGORY
// sectionProps: { SliderPunShow, showB }
// ─────────────────────────────────────────────────────────────────────────────

const ProductsByCategory = ({
    data,
    infoSource,
    sectionProps = {},    // ← AJOUT v5.2
    ...props
}) => {
    const {
        SliderPunShow = true,    // v5.1 avait true hardcodé
        showB         = true,    // v5.1 avait true hardcodé
    } = sectionProps;

    const categoryID = data;
    if (!categoryID) return null;

    return (
        <Products
            laguangeElakay={infoSource.laguangeElakay}
            infoSource={infoSource}
            categoryID={categoryID}
            SliderPunShow={SliderPunShow}
            showB={showB}
        />
    );
};

// ─────────────────────────────────────────────────────────────────────────────
// COMPOSANT: LAKAY USER SECTION
// sectionProps: { showB }
// ─────────────────────────────────────────────────────────────────────────────

const LakayUserSection = ({
    data,
    infoSource,
    sectionProps = {},    // ← AJOUT v5.2
    ...props
}) => {
    const { showB = true } = sectionProps;    // v5.1 avait true hardcodé
    const infoOwner = data;

    if (!infoOwner || !infoOwner.prod_Owner) return null;

    return (
        <LakayUser
            laguangeElakay={infoSource.laguangeElakay}
            infoSource={infoSource}
            addressShop={infoOwner.address}
            userID={infoOwner.prod_Owner}
            showB={showB}
        />
    );
};

// ─────────────────────────────────────────────────────────────────────────────
// COMPOSANT: NEW PRODUCT SECTION
// sectionProps: { showB }
// ─────────────────────────────────────────────────────────────────────────────

const NewProductSection = ({
    infoSource,
    sectionProps = {},    // ← AJOUT v5.2
    ...props
}) => {
    const { showB = true } = sectionProps;    // v5.1 avait true hardcodé

    return (
        <NewProduct
            laguangeElakay={infoSource.laguangeElakay}
            infoSource={infoSource}
            readUser={infoSource.readUser}
            showB={showB}
        />
    );
};

// ─────────────────────────────────────────────────────────────────────────────
// COMPOSANT: PRODUCT UNAVAILABLE
// sectionProps: {} — pas de config DB
// ─────────────────────────────────────────────────────────────────────────────

const ProductUnavailable = ({
    data,
    sectionProps = {},    // ← AJOUT v5.2 (non utilisé, prêt pour extension)
    ...props
}) => {
    if (!data) return null;

    return (
        <div className="product-unavailable-wrapper">
            <img
                src={EmptyProductImage}
                alt={__elakayText("t010", "Product unavailable")}
                className="product-unavailable-image"
            />
        </div>
    );
};

// ─────────────────────────────────────────────────────────────────────────────
// COMPOSANT: PRODUCT VIEW MAIN
// sectionProps: { showStock, showRating }
// ─────────────────────────────────────────────────────────────────────────────

const ProductViewMain = ({
    data,
    infoSource,
    sectionProps = {},    // ← AJOUT v5.2
    images,
    oneFilterPro,
    quantity,
    count,
    setcount,
    priceProd,
    etoiteProduct,
    inputCart,
    addToCart,
    Saddress,
    setSAddressFinal,
    addressShop,
    cartItemsPRoNew,
    parcel,
    galeries,
    unSeFil,
    setUnSefil,
    setImages,
    setOneFilterPro,
    setALLFilterPro,
    restAllFilterPro,
    allFilterPro,
    getQueryFil,
    setNewAP,
    setQuantity,
    laguangeElakay,
    ...props
}) => {
    const {
        showStock  = true,    // v5.1 montrait toujours le stock
        showRating = true,    // v5.1 montrait toujours le rating
    } = sectionProps;

    const getProduct = data || {};

    const stock = (a) => {
        if (!showStock) return null;
        if (a === 0) {
            return <h6 className="stock-label stock-unavailable">{infoSource.laguangeElakay('text', infoSource.languageAPI).textCardCart1}</h6>;
        } else if (a < 20) {
            return <h6 className="stock-label stock-low">{infoSource.laguangeElakay('text', infoSource.languageAPI).textCardCart2} {a} {infoSource.laguangeElakay('text', infoSource.languageAPI).textCardCart3}</h6>;
        } else if (a >= 20) {
            return <h6 className="stock-label stock-available">{infoSource.laguangeElakay('text', infoSource.languageAPI).textCardCart4}</h6>;
        }
    };

    return (
        <div className="product-preview-main">
            <div className="product-view-layout">
                <div className="product-gallery-column">
                    {images && images?.length > 0 && (
                        <EmblaCarousel slides={images} options={{}} infoSource={infoSource} />
                    )}
                </div>

                <div className="product-info-column">
                    <div className="product-info-card">
                        {showRating && <div className="product-rating-section">{etoiteProduct}</div>}
                        <h1 className="product-title">{getProduct.name}</h1>
                        <div
                            className="product-short-description"
                            dangerouslySetInnerHTML={{ __html: getProduct?.description }}
                        ></div>
                        <div className="product-price-section">
                            <Price showAddToCartButton={false} products={priceProd} />
                        </div>
                        <div className="product-stock-section">{stock(quantity)}</div>
                        <div className="product-quantity-section">{inputCart()}</div>
                    </div>

                    <div className="product-filters-section">
                        <PrevviewProFilt
                            infoSource={infoSource}
                            setQuantity={setQuantity}
                            galeries={galeries}
                            unSeFil={unSeFil}
                            setUnSefil={setUnSefil}
                            setImages={setImages}
                            oneFilterPro={oneFilterPro}
                            setOneFilterPro={setOneFilterPro}
                            setALLFilterPro={setALLFilterPro}
                            restAllFilterPro={restAllFilterPro}
                            allFilterPro={allFilterPro}
                            filter={getProduct?.filters}
                            getQueryFil={getQueryFil}
                            setNewAP={setNewAP}
                        />
                    </div>
                </div>

                <div className="product-checkout-column">
                    <div className="product-checkout-card">
                        <Checkout
                            Saddress={Saddress}
                            setSAddressFinal={setSAddressFinal}
                            graphic={getProduct.graphic}
                            addressShop={addressShop}
                            addressSel={infoSource.address}
                            products={cartItemsPRoNew}
                            quantity={quantity}
                            count={count}
                            parcel={parcel}
                            laguangeElakay={laguangeElakay}
                            infoSource={infoSource}
                        />
                        <button type="button" className="add-to-cart-button" onClick={addToCart}>
                            <MdAddShoppingCart className="cart-button-icon" />
                            {infoSource.laguangeElakay('Button', infoSource.languageAPI).addCart}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

// ─────────────────────────────────────────────────────────────────────────────
// COMPOSANT: PRODUCT DETAILS TABS
// sectionProps: {} — pas de config DB
// ─────────────────────────────────────────────────────────────────────────────

const ProductDetailsTabs = ({
    data,
    sectionProps = {},    // ← AJOUT v5.2 (non utilisé, prêt pour extension)
    oneFilterPro,
    ...props
}) => {
    const getProduct = data || {};

    const removeNotSpecified = (obj) => {
        for (const key in obj) {
            if (obj[key] === "Not Specified") {
                delete obj[key];
            }
        }
        return obj;
    };

    const objToArr = (a) => {
        a = removeNotSpecified(a);
        return a && { v: Object.values(a), k: Object.keys(a) };
    };

    const filterColor = oneFilterPro && oneFilterPro?.filter;
    const arrayFilter = objToArr(filterColor);

    const filterDetail = () => (
        <div className="filter-details-wrapper">
            <table className="filter-details-table">
                <tbody>
                    {arrayFilter &&
                        arrayFilter.k?.map((key, i) => (
                            <tr key={i} className={i % 2 === 1 ? "filter-row-alt" : "filter-row"}>
                                <td className="filter-label">{key}</td>
                                <td className="filter-value">: {arrayFilter.v[i]}</td>
                            </tr>
                        ))}
                </tbody>
            </table>
        </div>
    );

    const descriptionProduct = (
        <div className="product-description-content">
            {getProduct.note && getProduct.note?.length > 0 && getProduct.note?.map((k, j) => (
                k.tilte && (
                    <div key={j} className="product-note-item">
                        <p className="product-note-title">{k.tilte}</p>
                        <p className="product-note-description">{k.description}</p>
                    </div>
                )
            ))}
        </div>
    );

    const descrip = (
        <>
            <p>{getProduct.description}</p>
            {descriptionProduct}
        </>
    );

    return (
        <div className="product-details-tabs-section">
            <div className="product-details-tabs-wrapper">
                <TabsElakay title={__elakayText("t013", "details")}>
                    {tabElakay(filterDetail(), "details", "Details")}
                    {tabElakay(descrip, "description", "Description")}
                </TabsElakay>
            </div>
        </div>
    );
};

// ─────────────────────────────────────────────────────────────────────────────
// COMPOSANT: PRODUCT COMMENTS
// sectionProps: {} — pas de config DB
// ─────────────────────────────────────────────────────────────────────────────

const ProductComments = ({
    data,
    infoSource,
    sectionProps = {},    // ← AJOUT v5.2 (non utilisé, prêt pour extension)
    productId,
    token,
    skip,
    limit,
    loadProductsView,
    ButtonAddComments,
    showComments,
    setShowComments,
    commentProduct,
    ...props
}) => {
    const { commentsPro, getUserVote, setCommentsPro, SetSizeComments, setUserVote } = data || {};

    if (!commentsPro) return null;

    return (
        <CommentaireUser
            infoSource={infoSource}
            skip={skip}
            limit={limit}
            voteA={getUserVote}
            comments={commentsPro}
            productId={productId}
            token={token}
            setCommentsPro={setCommentsPro}
            SetSizeComments={SetSizeComments}
            setUserVote={setUserVote}
            setShowComments={setShowComments}
            commentProduct={commentProduct}
            loadProductsView={loadProductsView}
            ButtonAddComments={ButtonAddComments}
            showComments={showComments}
        />
    );
};

// ─────────────────────────────────────────────────────────────────────────────
// COMPOSANT: PRODUCT IMAGES NOTE
// sectionProps: {} — pas de config DB
// ─────────────────────────────────────────────────────────────────────────────

const ProductImagesNote = ({
    data,
    sectionProps = {},    // ← AJOUT v5.2 (non utilisé, prêt pour extension)
    ...props
}) => {
    const getProduct = data || {};

    if (!getProduct.note?.length) return null;

    return (
        <div className="product-images-note-section">
            <div className="product-images-note-wrapper">
                <div className="product-images-note-grid">
                    {getProduct.note?.map((k, j) => (
                        !k.tilte && (
                            <div key={j} className="product-note-image-item">
                                <img
                                    src={toImageUrl(k?.photoUrl) || `${elakay_API}/products/readNoteGalerie/${k?._id}/${j}`}
                                    alt={__elakayText("t011", "elakay note Images")}
                                    onError={event => {
                                        event.target.src = imgProductLakay;
                                        event.onerror = null;
                                    }}
                                    style={{ 
                        display: 'block',
                        margin: '0 auto',
                        width: "100%"
                        }}
                                />
                            </div>
                        )
                    ))}
                </div>
            </div>
        </div>
    );
};

// ─────────────────────────────────────────────────────────────────────────────
// COMPOSANT: PRODUCT COMMENTS MODAL
// sectionProps: { modalSize }
// ─────────────────────────────────────────────────────────────────────────────

const ProductCommentsModal = ({
    data,
    infoSource,
    sectionProps = {},    // ← AJOUT v5.2
    productId,
    loadProductsView,
    commentProduct,
    ...props
}) => {
    const { modalSize = 'xl' } = sectionProps;    // v5.1 avait "xl" hardcodé

    const {
        showComments,
        setShowComments,
        commentsPro,
        getUserVote,
        sizeComments,
        setUserVote,
        setCommentsPro,
        SetSizeComments,
        skip,
        limit,
        setSkip,
    } = data || {};

    return (
        <div className="comments-modal-container">
            <div className="comments-modal-wrapper">
                <Modal
                    size={modalSize}
                    show={showComments}
                    onHide={() => setShowComments?.(false)}
                    aria-labelledby="example-custom-modal-styling-title"
                    centered
                    className="product-comments-modal"
                >
                    <div className="m-4">
                        <button
                            className="tracking-close-btn"
                            onClick={() => setShowComments?.(false)}
                            aria-label={__elakayText("t004", "Close")}
                        >
                            ×
                        </button>
                        <AddCommentProduct
                            showComments={showComments}
                            ButtonAddComments={props.ButtonAddComments}
                            infoSource={infoSource}
                            ProductsViewload={loadProductsView}
                            comments={commentsPro}
                            userInfo={infoSource.userInfo}
                            voteA={getUserVote}
                            productId={productId}
                            setShowComments={setShowComments}
                            sizeComments={sizeComments}
                            commentProduct={commentProduct}
                            setUserVote={setUserVote}
                            setCommentsPro={setCommentsPro}
                            SetSizeComments={SetSizeComments}
                            size={commentsPro?.length}
                            skip={skip}
                            limit={limit}
                            setSkip={setSkip}
                        />
                    </div>
                </Modal>
            </div>
        </div>
    );
};

// ─────────────────────────────────────────────────────────────────────────────
// COMPOSANT: PRODUCT FULL VIEW
// sectionProps: transmis à ProductViewMain (showStock, showRating)
// ─────────────────────────────────────────────────────────────────────────────

const ProductFullView = ({
    data,
    infoSource,
    laguangeElakay,
    sectionProps = {},    // ← AJOUT v5.2
    images,
    oneFilterPro,
    quantity,
    count,
    setcount,
    priceProd,
    inputCart,
    addToCart,
    Saddress,
    setSAddressFinal,
    addressShop,
    cartItemsPRoNew,
    parcel,
    galeries,
    unSeFil,
    setUnSefil,
    setImages,
    setOneFilterPro,
    setALLFilterPro,
    restAllFilterPro,
    allFilterPro,
    getQueryFil,
    setNewAP,
    setQuantity,
    ...props
}) => {
    const getProduct = data || {};

    if (!getProduct._id) return null;

    const voteRating = ratingVote(getProduct.vote);
    const etoiteProduct = (
        <>
            {voteRating  && (<h5 className='p-0 m-0 product-star-rating'><Vote rating={voteRating} /></h5>)}
            {!voteRating && (<h5 className='p-0 m-0 product-star-rating'><Vote rating={0} /></h5>)}
        </>
    );

    return (
        <>
            <ProductViewMain
                data={getProduct}
                infoSource={infoSource}
                laguangeElakay={laguangeElakay}
                sectionProps={sectionProps}    // ← transmis à ProductViewMain
                images={images}
                oneFilterPro={oneFilterPro}
                quantity={quantity}
                count={count}
                setcount={setcount}
                priceProd={priceProd}
                etoiteProduct={etoiteProduct}
                inputCart={inputCart}
                addToCart={addToCart}
                Saddress={Saddress}
                setSAddressFinal={setSAddressFinal}
                addressShop={addressShop}
                cartItemsPRoNew={cartItemsPRoNew}
                parcel={parcel}
                galeries={galeries}
                unSeFil={unSeFil}
                setUnSefil={setUnSefil}
                setImages={setImages}
                setOneFilterPro={setOneFilterPro}
                setALLFilterPro={setALLFilterPro}
                restAllFilterPro={restAllFilterPro}
                allFilterPro={allFilterPro}
                getQueryFil={getQueryFil}
                setNewAP={setNewAP}
                setQuantity={setQuantity}
            />
            <ProductDetailsTabs data={getProduct} oneFilterPro={oneFilterPro} sectionProps={sectionProps} />
        </>
    );
};

// ─────────────────────────────────────────────────────────────────────────────
// COMPOSANT: SHOP HEADER
// sectionProps: { outOffPage, showFilter }
// ─────────────────────────────────────────────────────────────────────────────

const ShopHeader = ({
    data,
    infoSource,
    sectionProps = {},    // ← AJOUT v5.2
    userID,
    setFilterShop,
    onFilterShop,
    loadindSearCh,
    search,
    outOffPage,           // ← prop directe v5.1 (conservée)
    showFilter,           // ← prop directe v5.1 (conservée)
    myShop,
    setEditStore,
    editStore,
    ...props
}) => {
    // sectionProps prioritaire sur props directes
    const _outOffPage = sectionProps.outOffPage ?? outOffPage;
    const _showFilter = sectionProps.showFilter ?? showFilter;

    const shopOwner = data || {};
    const shopName  = shopOwner?.shopName
        ? (Array.isArray(shopOwner.shopName) ? shopOwner.shopName[0] : shopOwner.shopName)
        : 'seller';

    if (!_outOffPage) return null;

    return (
        <HeaderShopSeller
            infoSource={infoSource}
            userID={userID}
            setFilterShop={setFilterShop}
            onFilterShop={onFilterShop}
            shopName={shopName}
            loadindSearCh={loadindSearCh}
            search={search}
            outOffPage={_outOffPage}
            showFilter={_showFilter}
            myShop={myShop}
            setEditStore={setEditStore}
            editStore={editStore}
        />
    );
};

// ─────────────────────────────────────────────────────────────────────────────
// COMPOSANT: SHOP SLIDER PUB
// sectionProps: { text1, shop }
// ─────────────────────────────────────────────────────────────────────────────

const ShopSliderPub = ({
    data,
    infoSource,
    sectionProps = {},    // ← AJOUT v5.2
    shopOwner,
    swiperOptions,        // Swiper Settings: this section's own overrides
    ...props
}) => {
    const {
        text1 = `Voici un guide complet et pratique.; pour toutes les variantes.; de ThreeDText`,    // v5.1 avait ce texte hardcodé
        shop  = true,    // v5.1 avait true hardcodé
    } = sectionProps;

    const shopPub  = data || {};
    const owner    = shopOwner || {};
    const shopName = owner?.shopName
        ? (Array.isArray(owner.shopName) ? owner.shopName[0] : owner.shopName)
        : 'lakay';

    // Main Shop Slider Source: an Elakay Swiper replaces the image slider.
    return (
        <ShopHeroSlider hero={heroFromPub(shopPub)} ownerId={owner?._id || shopPub?._id || null}>
            <SliderPun135
                infoSource={infoSource}
                getpub={shopPub?.sliderShop}
                text1={text1}
                text2={shopName}
                shop={shop}
                swiperOptions={swiperOptions ?? sectionProps.swiperOptions}
            />
        </ShopHeroSlider>
    );
};

// ─────────────────────────────────────────────────────────────────────────────
// COMPOSANT: SHOP MODALS
// sectionProps: {} — structure fixe, pas de config DB
// ─────────────────────────────────────────────────────────────────────────────

const ShopModals = ({
    data,
    infoSource,
    sectionProps = {},    // ← AJOUT v5.2 (non utilisé, prêt pour extension)
    token,
    shopOwner,
    myShop,
    ...props
}) => {
    const {
        editStore,
        setEditStore,
        showAddShopName,
        setShowAddShopName,
        addressSelect,
        setAddressSelect,
        handleChange,
        clickEdit,
        selectAdress,
    } = data || {};

    const address = shopOwner?.address || [];

    const PromoUsPr = () => (
        <Modal show={editStore} onHide={() => setEditStore?.(false)} centered>
            <Modal.Body className="text-center">
                <h1 className="text-danger">🚀 {infoSource.laguangeElakay('title', infoSource.languageAPI).comingSoon}</h1>
            </Modal.Body>
        </Modal>
    );

    const pageAddPhoneAddress = () => (
        <div className="container">
            <div className="row justify-content-center">
                <Modal
                    size="lg"
                    show={showAddShopName}
                    onHide={() => setShowAddShopName?.(!showAddShopName)}
                    dialogClassName="modal-90w"
                    aria-labelledby="example-custom-modal-styling-title"
                    centered
                >
                    <Modal.Body>
                        <form className="m-3" onSubmit={clickEdit}>
                            <div className="form-group">
                                <label className="text-muted">
                                    {infoSource.laguangeElakay('sellPage', infoSource.languageAPI).adressShop}
                                </label>
                                <select
                                    onChange={selectAdress?.(address)}
                                    className="form-control"
                                    value={addressSelect?._id || '0'}
                                >
                                    <option value='0'>
                                        {infoSource.laguangeElakay('label', infoSource.languageAPI).pleaseSelect}
                                    </option>
                                    {address?.map((Adre, i) => (
                                        <option key={Adre._id || i} value={Adre._id}>
                                            ({Adre.firstName} {Adre.lastName}) {Adre.Address1}, {Adre.city} {Adre.State} {Adre.postalCode} {Adre.country}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="form-group">
                                <label className="text-muted">
                                    {infoSource.laguangeElakay("label", infoSource.languageAPI).shopName}
                                </label>
                                <input
                                    id="shop-name"
                                    onChange={handleChange?.("shopName")}
                                    type="text"
                                    placeholder={infoSource.laguangeElakay("label", infoSource.languageAPI).shopName}
                                    value={addressSelect?.shopName || ''}
                                    className="form-control"
                                />
                            </div>
                            <button className="btn btn-info pt-2 pb-2 pr-3 pl-3 rounded-4 float-right m-4">
                                {infoSource.laguangeElakay("Button", infoSource.languageAPI).save}
                            </button>
                        </form>
                    </Modal.Body>
                </Modal>
            </div>
        </div>
    );

    return (
        <>
            {PromoUsPr()}
            {myShop && pageAddPhoneAddress()}
        </>
    );
};

// ─────────────────────────────────────────────────────────────────────────────
// MAP DES COMPOSANTS  (identique v5.1)
// ─────────────────────────────────────────────────────────────────────────────

export const COMPONENTS_MAP = {
    'Slider'                     : Slider,
    'SliderWithLoading'          : SliderWithLoading,
    'LoadingSwiper'              : LoadingSwiper,
    'SwiperfollowShopUserMatrix' : SwiperfollowShopUserMatrix,
  'MatrixCardsGrid'            : MatrixCardsGrid,
    'SwiperCategoriesMatrix'     : SwiperCategoriesMatrix,
    'SwiperPubCategoryProdMatrix': SwiperPubCategoryProdMatrix,
    'FollowPage'                 : FollowPage,
    'ProductGridPage'            : ProductGridPage,
    "ProductGridShop"            : ProductGridShop,
    'CategoryProductsLoop'       : CategoryProductsLoop,
    'UserInfoCard'               : UserInfoCard,
    'UserButtonsGroup'           : UserButtonsGroup,
    'UserModal'                  : UserModal,
    'CartHeader'                 : CartHeader,
    'CartItemsList'              : CartItemsList,
    'CartCheckout'               : CartCheckout,
    'CartEmpty'                  : CartEmpty,
    'CartFullLayout'             : CartFullLayout,
    'OrdersHeader'               : OrdersHeader,
    'OrdersList'                 : OrdersList,
    'OrdersEmpty'                : OrdersEmpty,
    'OrdersFullLayout'           : OrdersFullLayout,
    'OrdersGridPage'             : OrdersGridPage,
    'OrdersModals'               : OrdersModals,
    'ProductsByCategory'         : ProductsByCategory,
    'LakayUserSection'           : LakayUserSection,
    'NewProductSection'          : NewProductSection,
    'ProductUnavailable'         : ProductUnavailable,
    'ProductViewMain'            : ProductViewMain,
    'ProductDetailsTabs'         : ProductDetailsTabs,
    'ProductComments'            : ProductComments,
    'ProductImagesNote'          : ProductImagesNote,
    'ProductCommentsModal'       : ProductCommentsModal,
    'ProductFullView'            : ProductFullView,
    'ShopHeader'                 : ShopHeader,
    'ShopSliderPub'              : ShopSliderPub,
    'ShopModals'                 : ShopModals,
    'Card'                       : Card,
    'ButtonPagination'           : ButtonPagination,
    'PaginationInfo'             : PaginationInfo,
    'ProductGridSearch'           :ProductGridSearch,
    'InvestmentHomeSection'       : InvestmentHomeSection,
    'InvestmentDetailSection'     : InvestmentDetailSection,
    'JobHomeSection'              : JobHomeSection,
    'JobDetailSection'            : JobDetailSection,
};

export const ASSETS = { elakayEmptyBox };

export const getComponent = (componentName) => {
    const component = COMPONENTS_MAP[componentName];
    if (!component) {
        console.warn(`[ComponentRegistry] Component "${componentName}" not found`);
        return null;
    }
    return component;
};

export const hasComponent      = (componentName) => componentName in COMPONENTS_MAP;
export const registerComponent = (name, component) => { COMPONENTS_MAP[name] = component; };
export const listComponents    = () => Object.keys(COMPONENTS_MAP);

export default COMPONENTS_MAP;
